import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import classes from './ExampleDegree.module.css';

const ExampleDegree = props => {
  const { t } = useTranslation(['register']);
  return (
    <div className={classes.container}>
      <p className={classes.title}>DIPLOMA</p>
      <div className={classes.degreeExampleContainer}>
        <div className={classes.infoContainer}>
          <p className={classes.userName}>
            {props.userName || props.userLastName
              ? `${props.userName} ${props.userLastName}`
              : 'Nombre Apellido'}
          </p>
          <figure className={classes.degreeExample}>
            <img
              className={classes.img}
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/background-diploma-register.jpg"
              alt="DiplomaRegistro"
            />
          </figure>
        </div>
      </div>
      <p className={classes.complementaryText}>
        {t('degree_text_1')}
      </p>
      <p className={classes.complementaryText}>
        <strong>{t('degree_text_2')}</strong>
      </p>
    </div>
  );
};

ExampleDegree.propTypes = {
  // eslint-disable-next-line react/require-default-props
  userName: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  userLastName: PropTypes.string
};

export default ExampleDegree;
